import instance from './instance';

export const getIvSurface = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/analytics/get_iv_curve', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching IV curve data:', error);
    throw error;
  }
};

export const getIvSkew = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/analytics/get_iv_skew', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching IV skew data:', error);
    throw error;
  }
};

export const getIvTermStructure = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/analytics/get_iv_term_structure', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching IV term structure data:', error);
    throw error;
  }
};

export const getAtmIv = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/analytics/get_atm_iv', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching ATM IV data:', error);
    throw error;
  }
};
